import { createContext, useContext, useReducer } from 'react';

const ThreadContext = createContext();

const initialState = {
  threads: [],
  currentThread: null,
  folders: [],
};

export const threadReducer = (state, action) => {
  switch (action.type) {
    case 'SET_THREADS':
      return {
        ...state,
        threads: action.payload
      };
    case 'SET_CURRENT_THREAD':
      return {
        ...state,
        currentThread: action.payload
      };
    case 'ADD_MESSAGE':
      if (state.currentThread?.id === action.payload.threadId) {
        return {
          ...state,
          currentThread: {
            ...state.currentThread,
            messages: [...(state.currentThread.messages || []), action.payload.message]
          },
          threads: state.threads.map(thread => 
            thread.id === action.payload.threadId
              ? {
                  ...thread,
                  messages: [...(thread.messages || []), action.payload.message]
                }
              : thread
          )
        };
      }
      return state;
    case 'UPDATE_THREAD_TITLE':
      return {
        ...state,
        threads: state.threads.map(thread =>
          thread.id === action.payload.threadId
            ? { ...thread, title: action.payload.title }
            : thread
        ),
        currentThread: state.currentThread?.id === action.payload.threadId
          ? { ...state.currentThread, title: action.payload.title }
          : state.currentThread
      };
    case 'UPDATE_STREAMING_MESSAGE':
      if (state.currentThread?.id === action.payload.threadId) {
        return {
          ...state,
          currentThread: {
            ...state.currentThread,
            messages: state.currentThread.messages.map((msg, idx) => 
              idx === state.currentThread.messages.length - 1
                ? { ...msg, content: action.payload.content }
                : msg
            )
          },
          threads: state.threads.map(thread => 
            thread.id === action.payload.threadId
              ? {
                  ...thread,
                  messages: thread.messages.map((msg, idx) => 
                    idx === thread.messages.length - 1
                      ? { ...msg, content: action.payload.content }
                      : msg
                  )
                }
              : thread
          )
        };
      }
      return state;
    case 'SET_FOLDERS':
      return {
        ...state,
        folders: action.payload
      };
    case 'ADD_FOLDER':
      return {
        ...state,
        folders: [...state.folders, action.payload]
      };
    case 'UPDATE_FOLDER':
      return {
        ...state,
        folders: state.folders.map(folder => 
          folder.id === action.payload.id ? action.payload : folder
        )
      };
    case 'MOVE_THREAD_TO_FOLDER':
      return {
        ...state,
        folders: state.folders.map(folder => {
          if (folder.id === action.payload.folderId) {
            return {
              ...folder,
              threads: [...folder.threads, action.payload.threadId]
            };
          }
          // Remove thread from other folders
          return {
            ...folder,
            threads: folder.threads.filter(id => id !== action.payload.threadId)
          };
        })
      };
    case 'SET_THREAD_DOCUMENT_CONTEXT':
      return {
        ...state,
        threads: state.threads.map(thread =>
          thread.id === action.payload.threadId
            ? { ...thread, documentContext: action.payload.documentContext, documentName: action.payload.documentName }
            : thread
        ),
        currentThread: state.currentThread?.id === action.payload.threadId
          ? { ...state.currentThread, documentContext: action.payload.documentContext, documentName: action.payload.documentName }
          : state.currentThread
      };
    default:
      return state;
  }
};

export const ThreadProvider = ({ children }) => {
  const [state, dispatch] = useReducer(threadReducer, initialState);

  return (
    <ThreadContext.Provider value={{ state, dispatch }}>
      {children}
    </ThreadContext.Provider>
  );
};

export const useThread = () => useContext(ThreadContext);
